import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useProductInformationStyles } from './styles';
import { formatDateWithoutTime } from '../../../../../helpers/DateFormatter';
import { textInCapitalCase } from '../../../../../helpers/TextHelper';

const ProductInformation = ({ ...props }) => {
  const { name, orderId, purchaseDate } = props;
  const classes = useProductInformationStyles();
  return (
    <Box display="flex" flexDirection="column" className={classes.container}>
      <Typography className={classes.title} data-cy="titleMobileProduct">
        {' '}
        {textInCapitalCase(name)}{' '}
      </Typography>
      <Typography className={classes.subtitle}>
        {' '}
        <span className={classes.subtitleWeight}>Nº de compra:</span> {orderId}{' '}
      </Typography>
      <Typography className={classes.subtitle}>
        {' '}
        <span className={classes.subtitleWeight}>Fecha de compra:</span>{' '}
        {formatDateWithoutTime(purchaseDate)}{' '}
      </Typography>
    </Box>
  );
};

ProductInformation.propTypes = {
  name: PropTypes.string,
  orderId: PropTypes.number,
  purchaseDate: PropTypes.string,
};

export default ProductInformation;
